export const FLATFILE_OUTPUT_LEVELS = {
  info: 'info',
  warning: 'warning',
  error: 'error',
}
